<div class="branding">
  <!-- Logo -->
  <div class="branding__logo">
    <img
      src="/assets/logos/cyflare-full-color-tagline-horizontal.png"
      alt="Cyflare One"
    />
  </div>

  <!-- Subtext -->
  <!-- commenting out while we prep marketing and details -->
  <!-- <p class="branding__subtext">
    Powered by
    <strong class="text-gradient-brand">Attack Compression Technology</strong>
  </p> -->

  <!-- Features Section -->
  <p class="branding__section-title">WHAT MAKES CYFLARE DIFFERENT</p>

  <div class="branding__features">
    @for (feature of features(); track feature.title) {
      <div class="feature-card">
        <h3 class="feature-card__title">{{ feature.title }}</h3>
        <p class="feature-card__description">{{ feature.description }}</p>
      </div>
    }
  </div>
  <!-- Partners Section -->
  <div class="branding__partners">
    <p class="branding__partners-title">Trusted by Partners Nationwide</p>
    <div class="branding__partners-logos">
      @for (partner of partners(); track partner.name) {
        <div class="partner-logo">
          @if (partner.logo) {
            <img
              [src]="partner.logo"
              [alt]="partner.name"
            />
          } @else {
            <div class="partner-logo__placeholder">{{ partner.name }}</div>
          }
        </div>
      }
    </div>
  </div>
</div>
